import { Component } from "react";
import Box from '@mui/material/Box';
import ProfileHeader from "../../../components/ProfileHeader";
import UnitsCatalog from "./UnitsCatalog";
import ProfileBottomNav from "../../../components/ProfileBottomNav";
import { getSessionStorage } from "../../../utils/StorageUtil";
import { USER_SO_KEY } from "../../../utils/accountUtils";

type Props = {};

type State = {
}

export default class extends Component<Props, State> {

  render() {
    return (
      <Box sx={{background: {xs: 'linear-gradient(#5EB07F 100px, #F2F3F1 155px)', sm: '#F2F3F1'}, backgroundAttachment: 'fixed'}}>
        <ProfileHeader></ProfileHeader>
        <UnitsCatalog></UnitsCatalog>
        {getSessionStorage(USER_SO_KEY) && <ProfileBottomNav goBack={true}></ProfileBottomNav> }
      </Box>
    );
  }
}